import {Container} from "./styles";
import externalLink from "../../assets/regular_icons/external-link.svg";
import gitIcon from "../../assets/regular_icons/github-svgrepo-com.svg";
import ScrollAnimation from "react-animate-on-scroll";

const projects = [
    {
        id: 1,
        title: "The Confidential Buzz",
        description:
            "A React-based chat app using Firebase for real-time data storage, with Google authentication for secure user access.",
        github: "https://github.com/tilakved/ConfidentialBuzz",
        liveDemo: "https://confidential-buzz.web.app/",
        technologies: ["React", "Firebase"],
    },
    {
        id: 2,
        title: "Hospitality Management System",
        description:
            "A comprehensive restaurant management system with eight integrated modules, including a reservation system, Dine-in app, POS, KDS, Insights, Kiosk, Planner, and Takeaway. It offers multi-payment integration, dynamic taxation, multi-currency support, inclusive tax calculations, internationalization, and socket-based real-time system interconnection.",
        github: "",
        liveDemo: "",
        technologies: ["React", "Node.js", "Socket.io", "Redux", "MongoDB"],
    },
    {
        id: 3,
        title: "ESG Insights 360",
        description:
            "A form-based ESG management application for tracking environmental, social, and governance data in large-scale industries. It enables data storage, ESG report generation, and real-time tracking of changes with a simple UI.",
        github: "",
        liveDemo: "",
        technologies: ["React", "Laravel", "SQL"],
    },
    {
        id: 4,
        title: "Exam Portal",
        description:
            "An all-in-one solution for taking aptitude and practical tests, featuring multiple types of questions, dynamic modules, integration of Monaco editor, and dynamic Python compilation with multi-language support.",
        github: "",
        liveDemo: "",
        technologies: ["React", "Python", "Django", "Flask"],
    },
    {
        id: 5,
        title: "Learning Management System",
        description:
            "A task-based learning system for newcomers to IT and other industries, featuring video playback with Fast Forward and Seek controls, and facilitating file submission, video, and multiple-choice questions.",
        github: "",
        liveDemo: "",
        technologies: ["Angular", "Laravel", "PostgreSQL", "SocketIO", "PWA"],
    },
    {
        id: 6,
        title: "Portfolio Website",
        description:
            "A modern and responsive portfolio built with React and Styled Components to showcase my projects and skills.",
        github: "https://github.com/tilakved/portfolio",
        liveDemo: "https://portfolio-tilakveds-projects.vercel.app/",
        technologies: ["React", "Styled Components"],
    },
    {
        id: 7,
        title: "String Calculator",
        description:
            "A modern, responsive string calculator which allows users to perform calculations on strings of numbers with various delimiters.",
        github: "https://github.com/tilakved/string-calculator.git",
        liveDemo: "https://string-calculator-app.vercel.app/",
        technologies: ["React", "Vite", "Tailwind"],
    },
    {
        id: 8,
        title: "Custom Calendar Plugin",
        description:
            "A fully responsive Custom Calendar with button click and static calendar page.",
        github: "https://github.com/tilakved/Calendar_Plugin_reservation.git",
        liveDemo: "https://calendar-plugin-reservation.vercel.app/",
        technologies: ["Angular"],
    },
    {
        id: 9,
        title: "Product Manager",
        description:
            "A dynamic product listing management system featuring product display, click tracking, image viewing, and user reviews. Built using dummy JSON data, custom hooks, and includes pagination for seamless navigation.",
        github: "https://github.com/tilakved/product-manager.git",
        liveDemo: "https://product-manager-bay.vercel.app/",
        technologies: ["React", "Vite"],
    },
    {
        id: 10,
        title: "Stepper Form",
        description:
            "A dynamic step-by-step form management system with diverse input types, selections, and validations. Built using custom hooks, Redux, and step-based navigation for a seamless user experience.",
        github: "https://github.com/tilakved/product-manager.git",
        liveDemo: "https://stepper-kappa.vercel.app/",
        technologies: ["React", "Redux"],
    },
    {
        id: 11,
        title: "React Forms",
        description:
            "A dynamic React form management system utilizing diverse input types and validations. Built with custom hooks, Redux, and left-sidebar navigation, it supports basic CRUD operations using localStorage for data persistence.",
        github: "https://github.com/tilakved/forms-react.git",
        liveDemo: "https://forms-react-chi.vercel.app/",
        technologies: ["Vite", "React", "Redux", "Tailwind"],
    },
    {
        id: 12,
        title: "Angular Metronic Theme",
        description:
            "An admin panel of Metronic cloned with diverse charts, data listings with filters, and multiple layouts.",
        github: "https://github.com/tilakved/angular-metronic-adminpanel.git",
        liveDemo: "https://angular-metronic-adminpanel.vercel.app/",
        technologies: ["Angular"],
    },
    {
        id: 13,
        title: "Admin Panel",
        description:
            "A comprehensive admin panel featuring diverse charts, data listings with filters, and a dual-sidebar layout (left and right) for enhanced navigation and usability.",
        github: "https://github.com/tilakved/react-admin-panel.git",
        liveDemo: "https://react-admin-panel-eta-swart.vercel.app/",
        technologies: ["React", "Vite", "Tailwind", "Apexcharts", "React-router"],
    },
    {
        id: 15,
        title: "Todo App",
        description:
            "Listing and saving your daily todo tasks, reminders and updates.",
        github: "https://github.com/tilakved/todo.git",
        liveDemo: "https://todo-tilakveds-projects.vercel.app/",
        technologies: ["React", "Tailwind"],
    },{
        id: 14,
        title: "Whitepace Landing Page",
        description:
            "A fully responsive landing page featuring multiple sections, including a hero section, about section, pricing plans, and multiple footer variations.",
        github: "https://github.com/tilakved/whitepace-landing-page.git",
        liveDemo: "https://whitepace-landing-page.vercel.app/",
        technologies: ["React", "Vite", "Tailwind"],
    },
];


export function Project() {
    return (
        <Container id="project">
            <h2>My Projects</h2>
            <div className="projects">
                {projects.map((project, index) => (
                    <ScrollAnimation
                        key={project.id}
                        animateIn={index % 2 === 0 ? "fadeInLeft" : "fadeInRight"}
                    >
                        <div className="project">
                            {/* NEW: Icons and Title in the Same Row */}
                            <header>
                                <h3 className="project-title">{project.title}</h3>
                                {project.github && project.liveDemo && <div className="project-links">
                                    <a href={project.github} target="_blank" rel="noreferrer">
                                        <img src={gitIcon} alt="GitHub Repository"/>
                                    </a>
                                    <a href={project.liveDemo} target="_blank" rel="noreferrer">
                                        <img src={externalLink} alt="Live Demo"/>
                                    </a>
                                </div>}
                            </header>

                            <figcaption>
                                <p>{project.description}</p>
                            </figcaption>

                            <footer>
                                <ul className="tech-list">
                                    {project.technologies.map((tech, i) => (
                                        <li key={i}>{tech}</li>
                                    ))}
                                </ul>
                            </footer>
                        </div>
                    </ScrollAnimation>
                ))}
            </div>
        </Container>
    );
}
